/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Sellers_Meta_TitleInputs */

const id_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ms_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const da_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const de_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const en_us2_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const es_es2_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const es_mx2_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const fil_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const fr_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const it_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const hu_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const nl_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const no_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const pl_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const pt_br2_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const pt_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ro_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const fi_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const sv_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const vi_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const tr_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const cs_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const bg_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ru_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const uk_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ar_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const hi_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const th_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ja_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const zh_cn2_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const zh_hant1_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ko_sellers_meta_title = /** @type {(inputs: Sellers_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

/**
* | output |
* | --- |
* | "{name} \| egdata.app" |
*
* @param {Sellers_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_meta_title = /** @type {((inputs: Sellers_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_meta_title(inputs)
	if (locale === "ms") return ms_sellers_meta_title(inputs)
	if (locale === "da") return da_sellers_meta_title(inputs)
	if (locale === "de") return de_sellers_meta_title(inputs)
	if (locale === "en-US") return en_us2_sellers_meta_title(inputs)
	if (locale === "es-ES") return es_es2_sellers_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_sellers_meta_title(inputs)
	if (locale === "fil") return fil_sellers_meta_title(inputs)
	if (locale === "fr") return fr_sellers_meta_title(inputs)
	if (locale === "it") return it_sellers_meta_title(inputs)
	if (locale === "hu") return hu_sellers_meta_title(inputs)
	if (locale === "nl") return nl_sellers_meta_title(inputs)
	if (locale === "no") return no_sellers_meta_title(inputs)
	if (locale === "pl") return pl_sellers_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_meta_title(inputs)
	if (locale === "pt") return pt_sellers_meta_title(inputs)
	if (locale === "ro") return ro_sellers_meta_title(inputs)
	if (locale === "fi") return fi_sellers_meta_title(inputs)
	if (locale === "sv") return sv_sellers_meta_title(inputs)
	if (locale === "vi") return vi_sellers_meta_title(inputs)
	if (locale === "tr") return tr_sellers_meta_title(inputs)
	if (locale === "cs") return cs_sellers_meta_title(inputs)
	if (locale === "bg") return bg_sellers_meta_title(inputs)
	if (locale === "ru") return ru_sellers_meta_title(inputs)
	if (locale === "uk") return uk_sellers_meta_title(inputs)
	if (locale === "ar") return ar_sellers_meta_title(inputs)
	if (locale === "hi") return hi_sellers_meta_title(inputs)
	if (locale === "th") return th_sellers_meta_title(inputs)
	if (locale === "ja") return ja_sellers_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_meta_title(inputs)
	return ko_sellers_meta_title(inputs)
});
export { sellers_meta_title as "sellers.meta.title" }